import { authHeader } from './auth-header';

export const userService = {
    login,
    logout,
    register,
    getAll,
};
const api = process.env.VUE_APP_API

async function login(email, password) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: email, password })
    };

    return fetch(`${api}/1/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            console.log("user: ", user)
            // login successful if there's a jwt token in the response
            if (user.data.auth) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user.data));
            }
            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return fetch(`/users/register`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.status_description) || response.statusText;
            console.log("error: ", error)
            return Promise.reject(error);
        }
        console.log("data: ", data)
        return data;
    });
}
